export default __webpack_public_path__ + "static/media/bombeo_solar_3.f86b889b.png";